export enum Wallets {
	WalletConnect = 'WalletConnect',
	Ledger = 'Ledger',
	WalletLink = 'WalletLink',
	MetaMask = 'MetaMask',
	Trezor = 'Trezor',
	CoinbaseWallet = 'Coinbase Wallet',
	Portis = 'Portis',
}
